<template>
    <div class="HelpBox" v-if="person" :class="{ 'is-opened': opened }">
        <div class="HelpBox-opener" @click="opened = !opened">
            <svg width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"></path></svg>
            <span>Nevíte si rady?</span>
        </div>
        <div class="HelpBox-content">
            <div class="HelpBox-title">Nevíte si rady?</div>
            <p class="HelpBox-perex">Kontaktujte nás:</p>
            <div class="HelpBox-person" v-if="person.name">
                <figure v-if="person.image">
                    <img :src="person.image.thumbnail" :alt="person.name" loading="lazy" />
                </figure>
                <div>
                    <div class="HelpBox-name">{{ person.name }}</div>
                    <span class="HelpBox-position">{{ person.position }}</span>
                </div>
            </div>
            <p class="HelpBox-contact">
                <span v-if="person.phone"><strong>Infolinka:</strong> <a :href="'tel:' + person.phone.replace(' ', '')">{{ person.phone }}</a></span><br/>
                <span v-if="person.email"><strong>E-mail:</strong> <a :href="'mailto:' + person.email">{{ person.email }}</a></span>
            </p>
            <p class="HelpBox-note">V případě jakýchkoliv dotazů se prosím na mě neváhejte obrátit, velice rád(a) Vám je všechny zodpovím.</p>
        </div>
    </div>
    <div class="HelpBox-cover" @click.self="opened = false"></div>
</template>

<script>
    import {ref} from 'vue';

    export default {
        props: {
            person: Object
        },
        setup() {
            const opened = ref(false);
            return { opened }
        }
    }
</script>

<style lang="scss" scoped>
.HelpBox {
    position: fixed;
    top: 9.6rem;
    left: 0;
    z-index: 4;
    transition: all .25s ease-in-out;
    transform: translateX(-100%);
    animation: slide-in .8s;

    @keyframes slide-in {
        0%, 50% { transform: translateX(calc(-100% - 10em)); }
        100% { transform: translateX(-100%) }
    }

    @media (max-width: 500px) {
        top: 8rem;

        &.is-opened {
            transform: translateX(0);
        }
    }

    @media(min-width: 501px) {
        &:hover {
            transform: translateX(0);
        }
    }

    &-opener {
        transform-origin: bottom left;
        transform: rotate(90deg) translateX(-28px) translateY(1px);
        position: absolute;
        left: 100%;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12.4em;
        background: var(--colorBrandSecondary);
        color: #fff;
        padding: 0.3em 1em;
        text-transform: uppercase;
        font-weight: 700;
        font-size: .9em;

        @media (max-width: 500px) {
            width: auto;
            transform: rotate(90deg) translateX(-20px);
        }

        span {
            margin-left: .5em;

            @media (max-width: 500px) {
                display: none;
            }
        }
    }

    &-cover {
        display: none;
        position: fixed;
        inset: 0;
        z-index: 3;

        .HelpBox.is-opened + & {
            display: block;
        }

        @media (min-width: 501px) {
            display: none !important;
        }
    }

    &-content {
        background: var(--colorBrandLighten);
        padding: 1.8em;
        width: 18rem;
        max-width: calc(100vw - 3rem);
        line-height: 1.4;
    }

    &-title {
        font-weight: 400;
        font-size: 1.375rem;
        margin: 0 0 .12em;
        color: var(--colorBrandDark);
    }

    &-perex {
        font-size: 1rem;
        font-weight: 600;
        margin: 0 0 1.5rem;
    }

    &-person {
        display: flex;
        align-items: center;
        margin: .625rem 0;

        figure {
            margin: 0 1em 0 0;
            width: 3.75em;
            aspect-ratio: 1;
            border-radius: 50%;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }

    &-name {
        font-size: 15px;
        font-weight: 700;
        letter-spacing: -.04em;
        color: var(--colorBrandDarken);
    }

    &-position {
        font-size: 13px;
        font-weight: 600;
        color: #4f4f4f;
    }

    &-contact {
        margin: .75rem 0 1.125rem;
        line-height: 1.64;

        a {
            color: var(--colorBrandDark);

            &:hover {
                text-decoration: none;
            }
        }
    }

    &-note {
        margin: 0;
        font-size: .75rem;
    }
}
</style>